<template>
    <div v-if="profilesToShow.length">
        <div class="mt-5">
            <h1>Количество мест</h1>
        </div>
        <div>
            <v-card
                class="mx-auto px-5 py-5 mt-5"
                min-width="30%"
                elevation="2"
                v-for="profile in profilesToShow"
                :key="profile._id"
            >
                <span class="font-weight-bold crisp"
                    >{{ profile.grade }} класс</span
                >
                <br />
                <h3>{{ profile.name }}</h3>
                <div class="mest">
                    <br />
                    <div v-if="profile.reserve">
                        Регистрация в резервный список
                    </div>
                    Осталось мест:
                    <span class="font-weight-bold">
                        {{ slotsAvailable(profile) }}
                    </span>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            profiles: [],
        }
    },
    created() {
        this.$axios.get('/api/profiles', {}).then((res) => {
            this.profiles = res.data.profileList
        })
    },
    computed: {
        profilesToShow: function () {
            return this.profiles.filter(function (profile) {
                return !profile.disabled
            })
        },
    },
    methods: {
        slotsAvailable: function (profile) {
            return profile.quantity - profile.index + 1 <= 0
                ? '0 - места для регистрации в данный профиль закончились'
                : profile.quantity - profile.index + 1
        },
    },
}
</script>

<style scoped>
.crisp {
    border-radius: 20px !important;
    padding: 3px;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #bdcfe4;
}
</style>
